import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconButtonPortalToolbarDirective } from './icon-button-portal-toolbar.directive';
import { IconButtonSmallDirective } from './icon-button-small.directive';
import { IconButtonToolbarDirective } from './icon-button-toolbar.directive';
import { IconButtonTooltipDirective } from './icon-button-tooltip.directive';
import { IconButtonUnboxedDirective } from './icon-button-unboxed.directive';
import { IconButtonDirective } from './icon-button.directive';

const DECLARATIONS = [
    IconButtonDirective,
    IconButtonSmallDirective,
    IconButtonUnboxedDirective,
    IconButtonToolbarDirective,
    IconButtonPortalToolbarDirective,
    IconButtonTooltipDirective
];

const EXPORTS = [
    IconButtonDirective,
    IconButtonSmallDirective,
    IconButtonUnboxedDirective,
    IconButtonToolbarDirective,
    IconButtonPortalToolbarDirective,
    IconButtonTooltipDirective
];

@NgModule({
    imports: [CommonModule],
    declarations: DECLARATIONS,
    exports: EXPORTS
})
export class IconButtonModule {
}
